import { Box, Card, CardContent, Typography } from "@mui/material"
import { formatCurrency } from "../../../helpers/formatters.js"
import Button from "@mui/material/Button"
import { useMutation } from "@tanstack/react-query"
import { purchaseProject } from "../../../api/project-api.js"
import { useTranslation } from "react-i18next"

export function CheckoutProject({ project, onSuccess }) {

  const { t } = useTranslation(["buy", "common"])
  const prices = {
    project: 1200,
    projectTax: 324
  }
  const purchaseMutation = useMutation({
    mutationFn: () => purchaseProject(project.id),
    onSuccess: onSuccess
  })

  function purchase() {
    purchaseMutation.mutate()
  }

  return (
    <Card>
      <CardContent>
        <Box sx={{ "display": "flex", gap: 2, alignItems: "center" }}>
          <Box
            component="img"
            sx={{ width: "60px", height: "60px", flexShrink: 0, borderRadius: 2 }}
            alt=""
            src={`${project.orthomosaicUrl}-300`}
            loading="lazy"
          />
          <Typography variant={"h6"}>{project.name}</Typography>
        </Box>
        <Box sx={{ height: "1px", width: "100%", backgroundColor: t => t.palette.divider, my: 2 }} />
        <Box sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 1,
          "& > *:nth-child(even)": { textAlign: "right" }
        }}>
          <Box sx={{ color: t => t.palette.text.secondary }}>{t("subTotal")}</Box>
          <Box sx={{ color: t => t.palette.text.primary }}>{formatCurrency(prices.project, "Ft")}</Box>
          <Box sx={{ color: t => t.palette.text.secondary }}>{t("vat")} (27%)</Box>
          <Box sx={{ color: t => t.palette.text.secondary }}>{formatCurrency(prices.projectTax, "Ft")}</Box>
          <Box sx={{ fontWeight: 700, fontSize: "20px" }}>{t("total")}</Box>
          <Box sx={{ fontWeight: 700, fontSize: "20px" }}>{formatCurrency(prices.projectTax, "Ft")}</Box>
          <Box sx={{
            gridColumn: "1 / -1",
            gridRow: 3,
            height: "1px",
            width: "100%",
            backgroundColor: t => t.palette.divider
          }} />
        </Box>
        <Button variant="contained" type="submit" sx={{ mt: 2, width: "100%" }} loading={purchaseMutation.isPending}
          onClick={purchase}>
          {t("purchase")}
        </Button>
      </CardContent>
    </Card>
  )
}